import React, { Component } from "react";
import _ from "lodash";
import { compose } from "redux";
import TemplateContainerMain from "components/Template";
import TemplateHeader from "components/Header";
import TemplateSidemenu from "components/Menu/Sidemenu";
import { Card, CardBody, Row, Col, Container, ModalBody } from "reactstrap";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import LoadingOverlay from "components/Indicator/LoadingOverlay";
import PageTitle from "components/Title/PageTitle";
import CustomTable from "components/Table";
import CustomModal from "components/Modal";
import ConfirmationModal from "components/Modal/confirmation";
import Pagination from "components/Pagination";
import FilterForm from "./Form";
import ManageBannerInhouseAPI from "./action.js";
import { RolesPermission } from "Config";
import moment from "moment";
import "./index.scss";
import { CheckUserRolesPermissons } from "actions/roles";

class ManageBannerInhouse extends Component {
	componentDidMount = () => {
		let tempModule = _.find(RolesPermission, {
			moduleID: CheckUserRolesPermissons(this.props.data.ProfileReducer.profile.roles).id,
		});

		if (tempModule && !tempModule.permissions.includes(7)) {
			return this.props.history.push("/");
		}

		this.props.getBanner();
	};

	componentDidUpdate = (pp) => {
		const { bannerInhousePages, getBanner } = this.props;
		const { filterQuery } = this.state;

		if (pp.bannerInhousePages !== bannerInhousePages) {
			getBanner(
				`${
					bannerInhousePages > 1
						? `&offset=${(bannerInhousePages - 1) * 10}`
						: ""
				}${!!filterQuery ? filterQuery : ""}`
			);
		}
	};

	state = {
		selectedRowData: null,
		filterQuery: "",
	};

	Publish = (val) => {
		this.props.onChangeHOC("selectedBannerId", val.bannerId);
		this.props.onChangeHOC("showPublishModal", true);
	};

	renderSampleTable = () => {
		const { bannerInhouseList, onLoadBanner, onChangeHOC } = this.props;

		return (
			<CustomTable
				data={bannerInhouseList}
				showPagination={false}
				loading={onLoadBanner}
				columnsContent={[
					{
						Header: "Banner ID",
						accessorKey: "id",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => <>{val.id}</>,
					},
					{
						Header: "Banner Title",
						accessorKey: "title",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => <>{val.title}</>,
					},
					{
						Header: "Links",
						accessorKey: "link_url",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => (
							<>
								{val.link_url && (
									<div style={{ marginBottom: "8px", padding: "4px", border: "1px solid #ddd", backgroundColor: "#f9f9f9" }}>
										<div style={{ fontWeight: "bold", marginBottom: "4px" }}>EN Images:</div>
										<div style={{ marginBottom: "2px" }}>
											<a href={val.link_url} target="_blank" rel="noopener noreferrer">
												{val.link_url}
											</a>
										</div>
										<div style={{ fontSize: "12px", marginTop: "4px", fontStyle: "italic" }}>
											Opens: {val.popup_image_en_url_open_count || 0}
										</div>
									</div>
								)}
								{val.link_url_cn && (
									<div style={{ padding: "4px", border: "1px solid #ddd", backgroundColor: "#f9f9f9" }}>
										<div style={{ fontWeight: "bold", marginBottom: "4px" }}>CN Images:</div>
										<div style={{ marginBottom: "2px" }}>
											<a href={val.link_url_cn} target="_blank" rel="noopener noreferrer">
												{val.link_url_cn}
											</a>
										</div>
										<div style={{ fontSize: "12px", marginTop: "4px", fontStyle: "italic" }}>
											Opens: {val.popup_image_cn_url_open_count || 0}
										</div>
									</div>
								)}
							</>
						),
					},
					{
						Header: "Status",
						accessorKey: "status",
						centerColumn: true,
						isStatusButton: true,
						Cell: (val) => <>{val.status}</>,
					},
					{
						Header: "Created Date",
						accessorKey: "created_at",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => (
							<>{moment(val.created_at).format("DD/MM/YYYY hh:mm A")}</>
						),
					},
					{
						Header: "Published Date",
						accessorKey: "start_date",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => (
							<>{moment(val.start_date).format("DD/MM/YYYY hh:mm A")}</>
						),
					},
				]}
				menuContent={(rowData) =>
					[4].includes(CheckUserRolesPermissons(this.props.data.ProfileReducer.profile.roles).id)
					? [
						{
							menuID: "PreviewPopup",
							menuTooltip: "Preview",
							type: "link",
						},
					]
					: [
						{
							menuID: "EditPopup",
							menuTooltip: "Edit",
							onClick: (val) => {
								this.props.history.push(`/banner-inhouse/edit/${val.id}`);
							},
						},
						{
							menuID: "PreviewPopup",
							menuTooltip: "Preview",
							type: "link",
						},
						// {
						// 	menuID: "PublishPopup",
						// 	menuTooltip: "Publish",
						// 	onClick: (val) => {
						// 		this.Publish(val);
						// 	},
						// },
						{
							menuID: "SuspendPopup",
							menuTooltip: rowData?.status === 'suspended' ? "Resume" : "Suspend",
							onClick: (val) => {
								this.setState({ selectedRowData: val });
								onChangeHOC("showSuspendModal", true);
							},
						},
					]
			}
			/>
		);
	};

	renderFilterModal = () => {
		const { getBanner, onChangeHOC, showFilterModal } = this.props;

		const customSetState = (newState) => {
			this.setState(newState);
		};

		return (
			<CustomModal
				size={"lg"}
				title="Banner Filter"
				isOpen={showFilterModal}
				onClose={() => onChangeHOC("showFilterModal", false)}>
				<FilterForm
					onSubmit={getBanner}
					onChangeHOC={onChangeHOC}
					handleState={customSetState}
				/>
			</CustomModal>
		);
	};

	renderEditModal = () => {
		return (
			<ConfirmationModal
				open={this.props.showEditModal}
				onClose={() => this.props.onChangeHOC("showEditModal", false)}
				onClickConfirm={() => this.props.onChangeHOC("showEditModal", false)}
				title={`Are you sure you want to edit this banner? ID: ${this.props.selectedBannerId}`}
				message="Please confirm this action."
				confirmContent="Yes, edit"
				confirmColor="danger"
			/>
		);
	};

	renderPublishModal = () => {
		return (
			<ConfirmationModal
				open={this.props.showPublishModal}
				onClose={() => this.props.onChangeHOC("showPublishModal", false)}
				onClickConfirm={() => this.props.onChangeHOC("showPublishModal", false)}
				title={`Are you sure you want to publish this banner? ID: ${this.props.selectedBannerId}`}
				message="Please confirm this action."
				confirmContent="Yes, publish"
				confirmColor="danger"
			/>
		);
	};

	renderSuspendModal = () => {
		const { selectedRowData } = this.state;
		const { showSuspendModal, onChangeHOC, updateBannerStatus } = this.props;
		
		const isCurrentlySuspended = selectedRowData?.status === 'suspended';
		const newStatus = isCurrentlySuspended ? 'active' : 'suspended';
		const actionText = isCurrentlySuspended ? 'activate' : 'suspend';

		return (
			<ConfirmationModal
				open={showSuspendModal}
				onClose={() => {
					this.setState({
						selectedRowData: null,
					});
					onChangeHOC("showSuspendModal", false);
				}}
				onClickConfirm={() => {
					updateBannerStatus(selectedRowData.id, newStatus);
					this.setState({
						selectedRowData: null,
					});
				}}
				title={`Are you sure you want to ${actionText} this banner? ID: ${selectedRowData?.id}`}
				message="Please confirm this action."
				confirmContent={`Yes, ${actionText}`}
				confirmColor="danger"
			/>
		);
	};
	render = () => {
		const {
			onChangeHOC,
			onLoadBanner,
			bannerInhousePages,
			bannerInhouseCount,
			getBanner,
		} = this.props;

		const { filterQuery } = this.state;

		return (
			<>
				<TemplateContainerMain>
					<TemplateHeader
						onClickToggleProfileModal={() => {}}
						history={this.props.history}
						user={this.props.data.ProfileReducer.profile}
					/>
					<div className="app-main">
						<TemplateSidemenu
							userPermissions={this.props.userPermissions}
							user={this.props.user}
							userRole={this.props.userRole}
						/>
						<div className="app-main__outer">
							<div className="app-main__inner">
								<>
									<PageTitle
										heading="Manage Banner / <b>Manage In-House Banner</b>"
										buttons={
											[4].includes(CheckUserRolesPermissons(this.props.data.ProfileReducer.profile.roles).id) 
											? [
												{
													color: "",
													className: "btn-outline-primary",
													onClick: () => onChangeHOC("showFilterModal", true),
													content: (
														<>
															<span>Filter</span>
														</>
													),
												},
											]
											: [
												{
													color: "primary",
													className: "btn-icon mr-2",
													onClick: () => {
														this.props.history.push("/banner-inhouse/create");
													},
													content: (
														<>
															<span>Create Banner</span>
														</>
													),
												},
												{
													color: "",
													className: "btn-outline-primary",
													onClick: () => onChangeHOC("showFilterModal", true),
													content: (
														<>
															<span>Filter</span>
														</>
													),
												},
											]
									}
									/>
									<ReactCSSTransitionGroup
										component="div"
										transitionName="TabsAnimation"
										transitionAppear={true}
										transitionAppearTimeout={0}
										transitionEnter={false}
										transitionLeave={false}>
										<h5>Manage In-House Banner</h5>
										<br></br>
										<Card className="main-card mb-3">
											<CardBody>
												{this.renderSampleTable()}
												<Pagination
													pageIndex={bannerInhousePages}
													totalCount={bannerInhouseCount}
													onChangePage={(val) =>
														onChangeHOC("bannerInhousePages", val)
													}
												/>
											</CardBody>
										</Card>
									</ReactCSSTransitionGroup>
									{this.renderFilterModal()}
									{this.renderEditModal()}
									{this.renderPublishModal()}
									{this.renderSuspendModal()}
									{this.props.onLoadBanner && <LoadingOverlay />}
								</>
							</div>
						</div>
					</div>
				</TemplateContainerMain>
			</>
		);
	};
}

export default compose(ManageBannerInhouseAPI)(ManageBannerInhouse);
